import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { MFilters } from 'types/filterTypes'
import { hashTable } from 'services/Utilities'
import { useUrlParams } from 'components/Hooks'
import useUpdateSettings from 'components/UI/Filter/hooks/useUpdateSettings'

const useEmployeeNumberQueryParam = (contentName: MFilters.ContentTypes) => {
  const { users } = useSelector((state: MStore.RootState) => state.resources)
  const usersByEmployeeNumber = useMemo(() => hashTable(users, 'employeeNumber'), [users])
  const [urlParams] = useUrlParams()
  const { saveOptions } = useUpdateSettings(contentName)

  useEffect(() => {
    const employeeNumberInParams = urlParams?.employeeNumber

    if (contentName === 'users' && employeeNumberInParams) {
      const employeeId = usersByEmployeeNumber[employeeNumberInParams]?._id
      // If the id doesn't exist, we want to make sure to clear the users filter so that it doesn't show the previous user filter
      const options = { users: employeeId ? [employeeId] : [] }
      saveOptions(options as MFilters.FilterTypes['filter-users'])
    }
  }, [contentName, saveOptions, urlParams, usersByEmployeeNumber])
}

export default useEmployeeNumberQueryParam
